import http from "@/http/aisea/axios";
const resource = "/hull_insurance/enterprises/enterprise_kind";

export default {
  fetch() {
    return http.get(`${resource}`);
  },
  fetchEnterpriseId() {
    return http.get(`${resource}/insurerOwner`);
  },
};
